import { axiosInstance } from "../../../utils/AxiosInstance/AxiosInstance";


export const updateQuotationMetaDataForPart = async (data) => {
    try {
        const response = await axiosInstance.post('/api/v2/admin/quotation/update-meta-data-for-part', data);
        return response.data;

    } catch (error) {
        throw new Error('Failed to create or update organization setup', error);
    }
};

export const uploadPartSnapShotData = async (data, refId, version) => {
    try {
        const response = await axiosInstance.post(
            `/api/v2/admin/quotation/upload-part-snapshot?RefId=${refId}&Version=${version}`,
            data, { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deletePartSnapShotData = async (data, ) => {
    try {
        const response = await axiosInstance.post(
            `/api/v2/admin/quotation/delete-part-snapshot`,
            data,
        );
        console.log("returning data ::",response.data);
        return response.data;
    } catch (error) {
        throw error;
    }
}